<script setup lang="ts">
defineProps<{
  type: 'primary' | 'secondary' | 'tertiary'
  as: 'button' | 'a' | 'router-link'
  active?: boolean
}>()
</script>

<template>
  <component
    :is="as"
    class="relative box-content flex h-10 w-10 flex-shrink-0 items-center justify-center rounded border font-semibold shadow-sidebar disabled:opacity-50"
    :class="{
      'border-tt-green bg-tt-green text-tt-gray': type === 'primary' || active,
      'border-tt-green text-tt-green': type === 'secondary' && !active,
      'border-tt-gray bg-tt-gray text-white hover:!border-tt-dark hover:!bg-tt-dark active:!border-tt-dark active:!bg-tt-dark [.mapboxgl-ctrl_&:not(:disabled):hover]:border-tt-dark [.mapboxgl-ctrl_&:not(:disabled):hover]:bg-tt-dark':
        type === 'tertiary' && !active
    }"
  >
    <div>
      <slot></slot>
    </div>
  </component>
</template>

<style lang="css" scoped>
.relative :deep() > * {
  position: absolute;
}
</style>
